import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="privacy-policy">
      <h1>Privacy Policy</h1>

      <h2>Welcome to the World Traveller Privacy Policy</h2>

      <p>
        When you use World Traveller services, you’re trusting us with your information. We
        understand this is a big responsibility and work hard to protect your information and put
        you in control. This Privacy Policy is meant to help you understand what information we
        collect, why we collect it, and how you can update, manage, export, and delete your
        information.
      </p>

      <h4>Version: 3</h4>
      <h5>Last modified: Jul 19, 2023. Policy takes effect on Jul 19, 2023.</h5>

      <p>
        World Traveller is a mobile application. Our goal is to provide a platform for people who
        want to track the countries, cities and places where they have been to.
      </p>

      <p>
        enoler built World Traveller as an Ad Supported app. This service is provided by enoler at
        no cost and is intended for use as is.
      </p>

      <p>
        This document is used to inform users regarding my policies with the collection, use, and
        disclosure of Personal Information if anyone decided to use our service.
      </p>

      <p>
        If you choose to use our service, then you agree to the collection and use of information in
        relation to this policy. The Personal Information that we collect is used for providing and
        improving the service. We will not use or share your information with anyone except as
        described in this Privacy Policy.
      </p>

      <p>
        The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions,
        which is accessible at World Traveller unless otherwise defined in this Privacy Policy.
      </p>

      <h1>Information Collection and Use</h1>

      <p>
        You can use our services in a variety of ways to manage your privacy. You can sign up for a
        World Traveller Account if you want to save your data and restore it once you sign in again.
        Additionally we offer the possibility of using our application without registration.
      </p>

      <p>
        When you login with some of our identity providers, Facebook and Google, we store some of
        the information that they provide. This information is stored encrypted in our servers and
        it is used only for the features that the application has. In any case this information is
        shared with any third-party company and is only used by World Traveller. We also collect the
        content you create when using our services. This includes the name of the cities, countries
        and places you have been to, and also your origin country.
      </p>

      <p>
        If you decide to not login, we will not save any kind of data on our servers unless you
        decide to help us with a translation. In this case we will store the email provided.
      </p>

      <p>
        The app does use third party services that may collect information used to identify you.
      </p>

      <p>Link to privacy policy of third party service providers used by the app</p>

      <p>
        <li>
          <a href="https://www.google.com/policies/privacy/">Google Play Services</a>
        </li>

        <li>
          <a href="https://support.google.com/admob/answer/6128543?hl=en">AdMob</a>
        </li>

        <li>
          <a href="https://firebase.google.com/policies/analytics">Firebase Analytics</a>
        </li>

        <li>
          <a href="https://www.facebook.com/policy.php">Facebook.</a>
        </li>

        <li>
          <a href="https://www.applovin.com/privacy/">Applovin.</a>
        </li>
      </p>

      <h1>We use data to build better services</h1>

      <p>We use the information we collect from all our services for the following purposes:</p>

      <h2>Provide our services</h2>

      <p>
        We use your information to deliver our services when you log in. We use it for saving the
        data and keeping the application state when you login again.
      </p>

      <h2>Develop new services</h2>

      <p>
        We use the information we collect in existing services to help us to develop new ones. For
        example, knowing the countries you have visited, we are able to do a ranking of the most
        visited countries.
      </p>

      <h2>Provide personalized services, focusing on contextual content</h2>

      <p>
        We use the information we collect to customize our services for you, including providing
        recommendations, personalized content, and customized statistics. For example, in the
        profile section.
      </p>

      <p>
        We also store a token related to your device, which is necessary to be able to send you
        notifications when somebody adds you or requests you a friendship.
      </p>

      <h2>Communicate with you</h2>

      <p>
        We use information we collect, like your email address, to interact with you directly. For
        example, we will send you an email if you send it to us to add or improve a translation. And
        if you contact World Traveller, we’ll keep a record of your request in order to help solve
        any issues you might be facing.
      </p>

      <p>
        <li>
          We show you ads in our mobile app. These ads are shown by Admob and we don’t use any
          particular personalized ads based on sensitive categories, such as race, religion, sexual
          orientation, or health. For more information, check the privacy policy of Admob.
        </li>
        <li>
          We don’t share information that personally identifies you with any partner or sponsor,
          such as your name or email, unless you ask us to.
        </li>
      </p>

      <h2>Data monitoring</h2>

      <p>
        We want to inform you that whenever you use our service, in case of an error in the app we
        collect data and information (through third party products) on your phone called Log Data.
        This Log Data may include information such as your device Internet Protocol (&quot;IP&quot;)
        address, device name, operating system version, the configuration of the app when utilizing
        our service, the time and date of your use of the Service, and other statistics.
      </p>

      <h2>Cookies</h2>

      <p>
        Cookies are files with a small amount of data that is commonly used as an anonymous unique
        identifier. These are sent to your browser from the website that you visit and are stored on
        your device internal memory.
      </p>

      <p>
        This service does not use these &quot;cookies&quot; explicitly. However, the app may use
        third party code and libraries that use &quot;cookies&quot; to collect information and to
        improve their services. You have the option to either accept or refuse these cookies and
        know when a cookie is being sent to your device. If you choose to refuse these cookies, you
        may not be able to use some portions of this service.
      </p>

      <h2>Service Providers</h2>

      <p>I may employ third-party companies and individuals due to the following reasons:</p>

      <p>
        <li>To facilitate my service;</li>

        <li>To provide the service on our behalf.</li>

        <li>To perform Service-related services.</li>

        <li>To assist us in analyzing how our service is used.</li>
      </p>

      <p>
        I want to inform users of this service that these third parties have access to your Personal
        Information. The reason is to perform the tasks assigned to them on our behalf. However,
        they are obligated not to disclose or use the information for any other purpose.
      </p>

      <h1>Your privacy controls</h1>

      <p>
        You have choices regarding the information we collect and how it’s used. This section
        describes key controls for managing your privacy across our services. You can also visit
        your settings, which provides an opportunity to review and adjust important privacy
        settings. In addition to these tools, we also offer specific privacy settings in our
        products, as well as signing out of the application.
      </p>

      <h2>Managing, reviewing, and updating your information</h2>

      <p>
        When you’re signed in, you can always update information while you use the application. For
        example, when you mark or unmark a country, a city or you change your origin country.
      </p>

      <p>
        You can always ask our support team to review and control information saved in your World
        Traveller Account.
      </p>

      <h2>Privacy controls</h2>

      <h3>Profile data</h3>

      <p>
        Your name, email and photo appear next to your profile. Other users can not see your real
        name and email, but they can see your nickname and your profile picture.
      </p>

      <p>
        Only when you set your account as private in the settings, other users will not be able to
        see your profile picture and any of your information, but still they will be able to find
        you by your nickname. We will show your information only if you accept the user to be your
        friend.
      </p>

      <h3>Ways to review &amp; update your information</h3>

      <h4>Countries and tutorials</h4>

      <p>
        It includes a map with all the countries that you have been marked as visited. Setting the
        country as visited or not, changes your data in our database. In the tutorial, you also
        choose your native country, which can be changed in the settings screen.
      </p>

      <h4>Cities</h4>

      <p>It works exactly the same as the countries section.</p>

      <h4>Other maps.</h4>

      <p>It works exactly the same as the countries section.</p>

      <h4>Your personal information</h4>

      <p>
        The email and name is provided for Facebook or Google when you sign in with one of these
        providers, and it can only be changed by contacting directly to us, or changing the
        information through your sign in providers.
      </p>

      <h3>Exporting, removing and deleting your information</h3>

      <p>
        You can export a copy of your data in the settings screen and also import it again if you
        need it.
      </p>

      <p>
        You can also request to remove content from specific World Traveller services based on
        applicable law.
      </p>

      <p>To delete your information, you can:</p>

      <p>
        <li>
          Search for and then delete specific items from your account using your countries, cities
          or other maps pages.
        </li>

        <li>
          Delete your entire World Traveller account by contacting us directly through&nbsp;
          <a href="https://www.worldtraveller.app/delete-account">this form</a>
          &nbsp;or using the option &quot;Delete account&quot; in the settings. This option removes
          all the information related to you in our servers.
        </li>
      </p>

      <p>
        There are other ways to control the information World Traveller collects whether or not
        you’re signed in to a World Traveller Account, including:
      </p>

      <p>
        <li>
          Device-level settings: Your device may have controls that determine what information we
          collect. For example, you can modify the notification settings.
        </li>
      </p>

      <h1>Sharing your information</h1>

      <h2>When you share your information</h2>

      <p>
        When you’re signed in and interact with some World Traveller services or other parties where
        World Traveller products are distributed, like leaving comments on World Traveller app store
        listing or rating the app in Google Play, your name and photo appear next to your activity.
        These portals may also display this information in ads and recommendations. Refer to their
        privacy policy for more detail.
      </p>

      <h2>When World Traveller shares your information</h2>

      <p>
        We do not share your personal information with companies, organizations, or individuals
        outside of World Traveller except:
      </p>

      <h3>For legal reasons</h3>

      <p>
        We will share personal information outside of World Traveller if we have a good-faith belief
        that access, use, preservation, or disclosure of the information is reasonably necessary to:
      </p>

      <p>
        <li>
          Meet any applicable law, regulation, legal process, or enforceable governmental request.
          We will let you know if we share information upon requests we receive from governments.
        </li>

        <li>
          Enforce applicable Terms of Service, including investigation of potential violations.
        </li>

        <li>Detect, prevent, or otherwise address fraud, security, or technical issues.</li>

        <li>
          Protect against harm to the rights, property or safety of World Traveller, our users, or
          the public as required or permitted by law.
        </li>
      </p>

      <p>
        If World Traveller is involved in a merger, acquisition, or sale of assets, we’ll continue
        to ensure the confidentiality of your personal information and give affected users notice
        before personal information is transferred or becomes subject to a different privacy policy.
      </p>

      <h3>Keeping your information secure</h3>

      <h4>We build security into our services to protect your information</h4>

      <p>
        All World Traveller products are using Firebase and a server hosted in Hetzner Cloud as host
        of your data, for more information about how they protect data, you can check their privacy
        policy.
      </p>

      <h4>Compliance and cooperation with regulators</h4>

      <p>
        We regularly review this Privacy Policy and make sure that we process your information in
        ways that comply with it.
      </p>

      <h5>Data transfers</h5>

      <p>
        The data is saved in Firebase and Hetzner Cloud servers. Therefore your information may be
        processed on servers located outside of the country where you live. Data protection laws
        vary among countries, with some providing more protection than others. Regardless of where
        your information is processed, we apply the same protections described in this policy. We
        also comply with certain legal frameworks relating to the transfer of data, such as the
        EU-US and Swiss-US Privacy Shield Frameworks.
      </p>

      <p>
        When we receive formal written complaints, we respond by contacting the person who made the
        complaint. We work with the appropriate regulatory authorities, including local data
        protection authorities, to resolve any complaints regarding the transfer of your data that
        we cannot resolve with you directly.
      </p>

      <h4>European requirements</h4>

      <p>
        If European Union (EU) data protection law applies to the processing of your information, we
        provide the controls described in this policy so you can exercise your right to request
        access to, update, remove, and restrict the processing of your information. You also have
        the right to object to the processing of your information or export your information to
        another service.
      </p>

      <p>
        We process your information for the purposes described in this policy, based on the
        following legal grounds:
      </p>

      <h5>When we’re pursuing legitimate interests</h5>

      <p>
        We process your information for our legitimate interests and those of third parties while
        applying appropriate safeguards that protect your privacy. This means that we process your
        information for things like:
      </p>

      <p>
        <li>Developing new products and features that are useful for our users.</li>

        <li>
          Understanding how people use our services to ensure and improve the performance of our
          services.
        </li>

        <li>Customizing our services to provide you with a better user experience.</li>

        <li>
          Protecting against harm to the rights, property or safety of World Traveller, our users,
          or the public as required or permitted by law.
        </li>

        <li>
          Performing research that improves our services for our users and benefits the public.
        </li>

        <li>Fulfilling obligations to our partners like developers and rights holders.</li>

        <li>
          Enforcing legal claims, including investigation of potential violations of applicable
          Terms and Conditions.
        </li>
      </p>

      <h5>When we’re providing a service</h5>

      <p>
        We process your data to provide a service you’ve asked for under a contract. For example, we
        process your payment information when you buy Premium features.
      </p>

      <h5>When we’re complying with legal obligations</h5>

      <p>
        We’ll process your data when we have a legal obligation to do so, for example, if we’re
        responding to a legal process or an enforceable governmental request.
      </p>

      <p>
        If you have questions, you can contact World Traveller support. And you can contact your
        local data protection authority if you have concerns regarding your rights under local law.
      </p>

      <h1>About this policy</h1>

      <h2>When this policy applies</h2>

      <p>
        This Privacy Policy applies to all of the services offered by enoler as developer. This
        Privacy Policy does not apply to services that have separate privacy policies that do not
        incorporate this Privacy Policy.
      </p>

      <p>This Privacy Policy does not apply to:</p>

      <p>
        <li>
          The information practices of other companies and organizations that advertise our
          services.
        </li>

        <li>
          Services offered by other companies or individuals, including products or sites that may
          include World Traveller services, be displayed to you in content on World Traveller sites
          and apps, or be linked from our services.
        </li>
      </p>

      <h2>Changes to this policy</h2>

      <p>
        We change this Privacy Policy from time to time. We will not reduce your rights under this
        Privacy Policy without your explicit consent. We always indicate the date the last changes
        were published and we offer access to archived versions for your review. If changes are
        significant, we’ll provide a more prominent notice (including, for certain services, email
        notification of Privacy Policy changes).
      </p>

      <h2>Security</h2>

      <p>
        I value your trust in providing us your Personal Information, thus we are striving to use
        commercially acceptable means of protecting it. But remember that no method of transmission
        over the internet, or method of electronic storage is 100% secure and reliable, and I cannot
        guarantee its absolute security.
      </p>

      <h2>Links to Other Sites</h2>

      <p>
        This service may contain links to other sites. If you click on a third-party link, you will
        be directed to that site. Note that these external sites are not operated by me. Therefore,
        I strongly advise you to review the Privacy Policy of these websites. I have no control over
        and assume no responsibility for the content, privacy policies, or practices of any
        third-party sites or services.
      </p>

      <h2>Children’s Privacy</h2>

      <p>
        These services do not address anyone under the age of 13. I do not knowingly collect
        personally identifiable information from children under 13. In the case I discover that a
        child under 13 has provided me with personal information, I immediately delete this from our
        servers. If you are a parent or guardian and you are aware that your child has provided us
        with personal information, please contact me so that I will be able to take necessary
        actions.
      </p>

      <h2>Contact Us</h2>

      <p>
        If you have any questions or suggestions about my Privacy Policy, do not hesitate to contact
        me to <a href="mailto:admin@worldtraveller.app">admin@worldtraveller.app</a>.
      </p>
    </div>
  );
}
